import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/core';
import { NG_HTTP_CACHING_CONFIG, NgHttpCachingBrowserStorage, NgHttpCachingConfig, NgHttpCachingInterceptorService, NgHttpCachingService, NgHttpCachingStrategy } from 'ng-http-caching';
import { ClientCacheAccessConnector } from './client-cache-access.connector';
import { ClientCacheInterceptor } from './client-cache.interceptor';
import { ClientCacheService } from '../client-cache.service';
import { DevConsoleProtocolLogger, injectableProtocolFactory } from '../../protocol';
import { CLIENT_CACHE_PROTOCOL } from '../client-cache';
import stringify from 'json-stringify-deterministic';
import { ConfigService } from '@core/shared/config';
import { BrowserSessionStorage } from '../../providers';
import * as i0 from "@angular/core";
import * as i1 from "./client-cache-access.connector";
// same as NgHttpCachingModule, but allows for customized providers , useful for debugging
export let ClientCacheModule = /*#__PURE__*/(() => {
  class ClientCacheModule {
    static forRoot(ngHttpCachingConfig = {}) {
      const defaultConfig = {
        version: VERSION,
        // store is platform dependent, managed in ClientCacheService constructor!
        // store: new NgHttpCachingSessionStorage(),
        lifetime: 10 * 60 * 1000,
        allowedMethod: ['GET', 'HEAD', 'POST'],
        cacheStrategy: NgHttpCachingStrategy.DISALLOW_ALL,
        getKey: req => {
          // it is unclear if HttpParams.toString orders params correctly, so we serialize manually to be safe
          const paramsMap = req.params.keys().reduce((map, key) => {
            const value = req.params.get(key);
            if (value === '') return map;
            map[key] = req.params.get(key);
            return map;
          }, {});
          return req.method + '__' + req.url + '__P' + stringify(paramsMap) + '__B' + stringify(req.body);
        }
      };
      return {
        ngModule: ClientCacheModule,
        providers: [{
          provide: NG_HTTP_CACHING_CONFIG,
          useFactory: (config, sessionStorage) => {
            return {
              ...defaultConfig,
              ngHttpCachingConfig,
              store: new NgHttpCachingBrowserStorage(sessionStorage)
            };
          },
          deps: [ConfigService, BrowserSessionStorage]
        }]
      };
    }
    constructor(s) {}
    static {
      this.ɵfac = function ClientCacheModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClientCacheModule)(i0.ɵɵinject(i1.ClientCacheAccessConnector));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: ClientCacheModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [ClientCacheService, ClientCacheInterceptor, {
          provide: NgHttpCachingInterceptorService,
          useExisting: ClientCacheInterceptor
        }, {
          provide: NgHttpCachingService,
          useExisting: ClientCacheService
        }, {
          provide: HTTP_INTERCEPTORS,
          useClass: ClientCacheInterceptor,
          multi: true
        }, injectableProtocolFactory(CLIENT_CACHE_PROTOCOL, 'ClientCache', [DevConsoleProtocolLogger])]
      });
    }
  }
  return ClientCacheModule;
})();